module.exports = __webpack_public_path__ + "static/media/Week7.27c6dda6.pdf";